import axios from 'axios';
import { API_URL } from '../config/env';

// Doğru API URL'sini sabit olarak tanımla
const BACKEND_URL = 'https://saticiyz-backend.saticiyiz.workers.dev';

// Axios instance oluştur
const api = axios.create({
  baseURL: BACKEND_URL, // API_URL yerine doğrudan sabit URL'yi kullan
  headers: {
    'Content-Type': 'application/json',
  },
  // CORS için cookies/credentials izinleri - CORS hatası nedeniyle false yapıldı
  withCredentials: false,
  timeout: 30000 // 30 saniye timeout
});

// İstek interceptor
api.interceptors.request.use(
  (config) => {
    // Eğer token varsa ekle
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Cevap interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // CORS hatalarını yakala
    if (error.code === 'ERR_NETWORK') {
      console.error('CORS veya ağ hatası:', error);
      // Kullanıcı dostu hata mesajı
      error.message = 'API sunucusuna bağlanırken bir sorun oluştu. CORS veya ağ hatası olabilir.';
    }
    
    // 401 hataları için oturum süresinin bittiğini kontrol et
    if (error.response && error.response.status === 401) {
      // Token geçersiz olduğunda kullanıcıyı logout et
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

// Güvenli API çağrısı yapan yardımcı fonksiyon
const safeApiCall = async (apiFunction, fallbackValue = null) => {
  try {
    console.log(`API isteği yapılıyor...`);
    const response = await apiFunction();
    console.log(`API yanıtı:`, response.data);
    return response.data;
  } catch (error) {
    console.log('\n            \n            \n           ', error);
    console.error(`API hatası: ${error.message}`, error.response?.data || error);
    // 404 hata kodu ise fallback değerini döndür
    if (error.response?.status === 404) {
      console.log('Kaynak bulunamadı, varsayılan değer döndürülüyor', fallbackValue);
      return fallbackValue;
    }
    
    // 500 hata kodu ise sunucu hatası
    if (error.response?.status === 500) {
      console.log('Sunucu hatası, varsayılan değer döndürülüyor', fallbackValue);
      return fallbackValue;
    }
    
    return fallbackValue;
  }
};

// API fonksiyonları
const apiService = {
  // Kullanıcı ile ilgili API çağrıları
  auth: {
    login: (credentials) => api.post('/users/login', credentials),
    register: (userData) => api.post('/users/register', userData),
    verify: (token) => api.post('/users/verify', { token }),
    getProfile: () => api.get('/users/profile'),
  },
  
  // Ürünler ile ilgili API çağrıları
  products: {
    getAll: (params) => safeApiCall(() => api.get('/api/trendyol/products', { params }), { products: [] }),
    sync: () => api.post('/api/trendyol/products/sync'),
    getById: (id) => safeApiCall(() => api.get(`/api/trendyol/products/${id}`), {}),
    update: (id, data) => api.put(`/api/trendyol/products/${id}`, data),
  },
  
  // Siparişler ile ilgili API çağrıları
  orders: {
    getAll: (params) => safeApiCall(() => api.get('/api/orders', { params }), { orders: [] }),
    sync: () => api.post('/api/orders/sync'),
    getById: (id) => safeApiCall(() => api.get(`/api/orders/${id}`), {}),
    update: (id, data) => api.put(`/api/orders/${id}`, data),
  },
  
  // Dashboard ile ilgili API çağrıları
  dashboard: {
    getStats: () => safeApiCall(() => api.get('/api/dashboard/stats'), { stats: {} }),
  },
  
  // Ayarlar ile ilgili API çağrıları
  settings: {
    getProfile: () => safeApiCall(() => api.get('/settings/profile'), { 
      first_name: '', 
      last_name: '', 
      email: '',
      phone: '',
      api_settings: { seller_id: '', api_key: '', api_secret: '' }
    }),
    updateProfile: (data) => api.put('/settings/profile', data),
    getApiSettings: () => safeApiCall(() => api.get('/settings/api'), { 
      seller_id: '', 
      api_key: '', 
      api_secret: '' 
    }),
    updateApiSettings: (data) => safeApiCall(() => api.put('/settings/api-settings', data), {
      seller_id: '', 
      api_key: '', 
      api_secret: '' 
    }),
  },
};

export default apiService; 